var getButtonTheme = theme => ({
  colors: {
    primary: {
      background: {
        initial: theme.colors.ultraViolets[70]
      },
      foreground: {
        initial: theme.colors.white
      }
    },
    secondary: {
      background: {
        initial: theme.colors.white,
        hover: theme.colors.ultraViolets[10],
        active: theme.colors.ultraViolets[30],
        focus: theme.colors.ultraViolets[10]
      },
      foreground: {
        initial: theme.colors.ultraViolets[70]
      },
      boxShadow: theme.colors.ultraViolets[20]
    },
    danger: {
      background: {
        initial: theme.colors.reds[50]
      },
      foreground: {
        initial: theme.colors.white
      }
    },
    success: {
      background: {
        initial: theme.colors.blue
      },
      foreground: {
        initial: theme.colors.white
      }
    },
    link: {
      background: {
        active: theme.colors.ultraViolets[20],
        hover: theme.colors.ultraViolets[10]
      },
      foreground: {
        initial: theme.colors.greys[100]
      }
    },
    default: {
      background: {
        initial: theme.colors.white
      },
      foreground: {
        initial: theme.colors.ultraViolets[70]
      }
    },
    disabled: {
      background: {
        initial: theme.colors.greys[20]
      },
      foreground: {
        initial: theme.colors.greys[40],
        hover: theme.colors.greys[40]
      }
    }
  }
});
export { getButtonTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
